import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginVerifierUser } from '../login/api.actions';
import history from '../history';
import '../resources/stylesheets/login.css';
import clorianLogo from '../resources/images/clorian-logotipo.png';
import {Login} from "clorian-frontend-components";

const USER_URL = process.env.REACT_APP_USER_SERVICE_URL;

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false
    };
    this.handlerLogin = this.handlerLogin.bind(this);
  }

  componentWillMount() {
    localStorage.clear();
    sessionStorage.clear();
  }

  handlerLogin(creds) {
    this.setState({
      disabled: true
    });

    const { dispatch } = this.props;
    dispatch(loginVerifierUser(creds))
      .then(response => {
        if (response && response.isAuthenticated) {
          setTimeout(() => {
            history.push('/validatorSelection');
          }, 1500);
        } else {
          console.log(response);
          this.setState({
            disabled: false,
            error: response
          });
        }
      })
      .catch(function(e) {
        console.log(e.message);
      });
  }

  render() {
    const { disabled, error } = this.state;
    return (
      <Login
        onSubmit={this.handlerLogin}
        logo={clorianLogo}
        disabled={disabled}
        error={error}
        hasResetPassword={true}
        userService={USER_URL}
        module="verifier"
      />
    );
  }
}

export default connect()(LoginContainer);
